import { Component, OnInit, ViewChild, AfterContentInit } from '@angular/core';
import { OrderBatchLogisticsWizardService } from '../../../../services/wizard/logistic/order-batch-send-wizard.service';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SendOrderLogisticsDetailComponent } from '../send-order-logistics-detail/send-order-logistics-detail.component';
import { WizardStep } from '../../../../wizard/wizard.component';
import { MatTabGroup } from '@angular/material/tabs';
import { SendOrderLogisticsItemComponent } from '../send-order-logistics-item/send-order-logistics-item.component';
import { ReceiveOrderLogisticsItemComponent } from '../receive-order-logistics-item/receive-order-logistics-item.component';
import { ConfirmDialogService } from '../../../../services/confirm-dialog.service';

@Component({
  selector: 'app-receive-order-logistics-wizard',
  templateUrl: './receive-order-logistics-wizard.component.html',
  providers: [{ provide: OrderBatchLogisticsWizardService, useClass: OrderBatchLogisticsWizardService }]
})

export class ReceiveOrderLogisticsWizardComponent implements OnInit, AfterContentInit {
  loadingAction: boolean;
  loading: boolean;
  @ViewChild('tabGroup', {static: false}) tabGroup: MatTabGroup;
  @ViewChild('sendOrderLogisticsDetail', {static: false}) sendOrderLogisticsDetail: SendOrderLogisticsDetailComponent;
  @ViewChild('receiveOrderLogisticsItem', {static: false}) receiveOrderLogisticsItem: ReceiveOrderLogisticsItemComponent;

  constructor(private notificationToastService: NotificationToastService
    , private orderBatchSendWizardService: OrderBatchLogisticsWizardService
    , private confirmDialogService: ConfirmDialogService
    , private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.route.params.subscribe(async (params) => {
      try {
        const orderBatchId = params['Id'] ? params['Id'] : null;
        await this.orderBatchSendWizardService.initialize(orderBatchId, true);
        setTimeout(() => {
          this.sendOrderLogisticsDetail.activate();
        }, 0);
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err), 'Envio de órdenes');
      } finally {
        this.loading = false;
      }
    });
  }

  cancel(): void {
    history.back();
  }

  async receive() {
    if (!this.validateSteps(this.getSteps().length - 1)) {
     this.confirmDialogService.confirm('Recepción de ordenes'
      , '¿Está seguro de recibir las Órdenes ingresadas? Las Órdenes no seleccionadas pasarán a estado "No recibido".'
      , 'Sí', 'No' ).subscribe(async (value) => {
        if (value) {
          try {
            this.loadingAction = true;
            if (await this.orderBatchSendWizardService.orderBatchReceive()) {
              this.cancel();
            }
          } catch (err) {
            this.notificationToastService.error(JSON.stringify(err), 'Recepción de órdenes');
          } finally {
            this.loadingAction = false;
          }
        }
      });
    }
  }

  ngAfterContentInit(): void {

  }

  selectedIndexChange(newIndex: number): void {
    this.validateSteps(newIndex);
    const steps = this.getSteps();
    if (steps.length > newIndex) {
      steps[newIndex].activate();
    }
  }

  private validateSteps(newIndex: number): boolean {
    const steps = this.getSteps();
    let inx = 0;
    let hasError = false;
    while (inx <= newIndex && steps.length > inx && !hasError) {
      hasError = !steps[inx].completed;
      if (!hasError)
        steps[inx].save();
      inx = inx + 1;
    }
    if (hasError) {
      this.tabGroup.selectedIndex = inx - 1;
    }
    return hasError;
  }

  private getSteps() {
    const steps: WizardStep[] = [];
    // se tienen que agregar los pasos en el mismo orden que aparecen
    if (this.sendOrderLogisticsDetail
      && this.sendOrderLogisticsDetail.isInit) {
      steps.push(this.sendOrderLogisticsDetail);
    }

    if (this.receiveOrderLogisticsItem
      && this.receiveOrderLogisticsItem.isInit) {
      steps.push(this.receiveOrderLogisticsItem);
    }
    
    return steps;
  }
}
